__turbopack_context__.v({
  "__withPhoto": "ProfileButton-module-scss-module__2z4Lgq____withPhoto",
  "button": "ProfileButton-module-scss-module__2z4Lgq__button",
  "dropdownMenuItem": "ProfileButton-module-scss-module__2z4Lgq__dropdownMenuItem",
});
